export default {
  // 导航菜单
  nav: {
    home: '首页',
    intro: '项目介绍',
    market: '市场机遇',
    tech: '技术架构',
    aiQuant: 'AI量化',
    chainGame: '链游戏',
    nft: 'NFT',
    // static: '收益产品',
    dynamic: '推广模型',
    roadmap: '发展路线图',
    contact: '联系我们',
  },
  // 通用
  common: {
    comingSoon: '待开放',
  },
  // 首页
  home: {
    title: '鲸鱼生态',
    subtitle:
      '致力于构建一个集实体算力锚定、AI增强的量化策略与社区化治理于一体的去中心化金融平台',
    intro: {
      title: '项目介绍',
      desc: '了解鲸鱼生态的愿景和使命',
    },
    market: {
      title: '市场机遇',
      desc: '探索数字资产市场的新趋势',
    },
    tech: {
      title: '技术架构',
      desc: '了解核心技术架构与安全保障',
    },
    token: {
      title: '通证经济',
      desc: '$TRUMPDOGE 经济模型详解',
    },
    ecosystem: {
      title: '生态应用',
      desc: '强大的收益来源与生态布局',
    },
    // static: {
    //   title: '静态收益',
    //   desc: '固定周期的锁仓收益方案',
    // },
    dynamic: {
      title: '推广模型',
      desc: '动态推广奖励机制',
    },
    roadmap: {
      title: '发展路线图',
      desc: '清晰的生态发展路径',
    },
    aiQuant: {
      title: 'AI量化',
      desc: 'AI增强的量化交易策略',
    },
  },
  // 联系我们页面
  contact: {
    aboutUs: '关于我们',
    aboutText1:
      '近10年的发展历程，黎明软件科技始终坚持"创新-严谨-诚信-共赢"的发展理念。现拥有众多领域的优秀案例，与各大互联网企业达成局部合作关系，并先后成为众多网络公司的战略合作伙伴，这也是对黎明软件科技科技的极大肯定。',
    aboutText2:
      '黎明软件科技网络的成员有着长时间的行业工作经验，凝聚着一批高素质的客户管理人员和经验丰富的技术人员，吸引了一批行业内优秀的年轻人，他们来自IT技术和创意艺术的前沿阵地，富有创造力和奉献精神，是黎明软件科技网络领先的前提保证，也是黎明软件科技重要的财富。',
    corporate: '企业文化',
    vision: '愿景',
    visionText:
      '黎明软件科技立志成为国内领先的IT技术服务及行业解决方案市场的领导者。',
    mission: '使命',
    missionText:
      '黎明软件一直秉承，以创新思想和领先技术，持续为客户创造更多价值。',
    values: '价值观',
    valuesText: '品质、创新、学习、同创共享',
    contactUs: '联系我们',
  },
  // 项目介绍
  intro: {
    title: '项目介绍',
    content:
      '鲸鱼生态致力于构建一个集实体算力锚定、AI增强的量化策略与社区化治理于一体的去中心化金融平台。我们旨在通过区块链技术和创新的通证经济模型，打造一个透明、可持续且具备强劲真实收益能力的数字资产增值生态系统。平台通证 $TRUMPDOGE 作为生态价值核心载体，共享生态发展的长期红利。',
  },
  // 发展路线图
  roadmap: {
    title: '发展路线图',
    description: '我们的发展路径清晰，旨在稳步实现生态愿景。',
    phase1: {
      title: '阶段1.0 (已完成)',
      content: '完成算力与AI交易核心模块整合，实现U提现与平台币兑换。',
    },
    phase2: {
      title: '阶段2.0 (进行中)',
      content: '建立百万用户社区，强化持币者共识。',
    },
    phase3: {
      title: '阶段3.0 (未来)',
      content: '推动 $TRUMPDOGE 登陆全球一线交易所，与主流货币共享财富盛宴。',
    },
    phase4: {
      title: '阶段4.0 (未来)',
      content:
        '开发及融合平台多元化生态（如DeFi、NFT，链游等），实现投资和回报持续稳定长久增值。',
    },
  },
  // 页脚
  footer: {
    contactUs: '联系我们',
    contactEmail: '联系邮箱',
  },
  // 市场机遇
  market: {
    title: '市场背景与机遇',
    intro: '当前数字资产市场正经历深刻变革，呈现出新的趋势：',
    feature1: {
      title: '机构化与多元化',
      content:
        '在比特币等主流资产创下新高后，部分加密鲸鱼开始将投资组合多元化，寻找更具潜力的机会。这为具备创新模式和真实价值支撑的新兴项目带来了发展窗口。',
    },
    feature2: {
      title: 'AI与预测市场的融合',
      content:
        'AI预测市场模型正在重塑相关领域，通过算法处理市场信息、优化流动性并提供动态定价，这为提升平台策略的效率和透明度提供了技术借鉴。',
    },
    feature3: {
      title: '真实收益需求',
      content:
        '投资者越来越青睐由真实业务收入和实体资产支撑的收益模型，而非完全依赖代币通胀的激励。',
    },
  },
  // 技术架构
  tech: {
    title: '核心技术架构',
    intro: '我们的技术栈旨在确保平台的效率、安全性与可扩展性。',
    item1: {
      title: '混合链架构',
      content:
        '结合公有链的透明度与侧链的高效处理能力，确保核心资产数据不可篡改的同时，提升交易速度，降低用户手续费。',
    },
    item2: {
      title: '模块化智能合约',
      contract1:
        '收益分配合约：自动执行静态收益与动态推广奖励，确保规则透明、分配准确。',
      contract2:
        'AI策略金库合约：管理用户投入的资产，执行预设的AI量化与高频交易策略，利润自动分配。',
      contract3:
        '通证销毁合约：所有平台币卖出交易将自动销毁，通证数据永久可查，创造通缩压力。',
    },
    item3: {
      title: '安全与审计',
      security1:
        '多重签名钱包：管理平台核心资产，任何资金调动都需要多个授权密钥，杜绝单点风险。',
      security2:
        '第三方智能合约审计：计划由业内知名的安全公司对核心合约进行审计，以增强用户信任。',
    },
  },
  // 通证经济
  token: {
    title: '通证经济模型 ($TRUMPDOGE)',
    intro:
      '$TRUMPDOGE是鲸鱼生态的治理与价值核心，其设计遵循可持续发展的经济模型。',
    details1: {
      title: '通证详情',
      name: '名称：TrumpDoge',
      symbol: '符号：$TRUMPDOGE',
      supply: '总供应量：2100亿（全部通过质押挖矿产出，无预挖）',
    },
    details2: {
      title: '价值支撑与通缩机制',
      mechanism1:
        '利润回购与销毁：平台所有业务（算力、AI交易、生态应用）的部分净利润，定期回购并销毁 $TRUMPDOGE。',
      mechanism2:
        '交易即销毁：所有 $TRUMPDOGE 的卖出行为，将产生一定比例的交易费并直接销毁，实现"卖出即通缩"，打造无限通缩价值。',
      mechanism3:
        '质押生息：用户可质押 $TRUMPDOGE 以获得额外收益分红，有效锁定流动性，减少市场抛压。',
    },
    details3: {
      title: '通证分配',
      content:
        '100%通过参与平台生态（如算力质押、流动性提供等）产出，确保社区公平启动。',
    },
  },
  // 生态应用
  ecosystem: {
    title: '生态应用与收益来源',
    intro: '强大的生态应用是平台产生真实收益、实现"造血"的基石。',
    item1: {
      title: '实体算力挖矿中心',
      content:
        '将实体矿场产出的BTC、ETH、FIL等主流币收益，通过算力销售的形式分配给用户，提供稳定的底层收益。',
    },
    item2: {
      title: 'AI量化与高频交易',
      content:
        '专业团队利用AI算法在各大交易所进行高频套利和趋势交易，捕捉市场波动带来的利润，作为用户收益的增强来源。这部分业务模式与AI预测市场模型中利用算法优化策略的思路有相似之处。',
    },
    item3: {
      title: '多元化生态布局',
      content:
        '业务还涵盖矿机销售、技术托管、交易所经营等，形成一个自循环的商业闭环。',
    },
  },
  // 静态收益
  // static: {
  //   title: '静态收益产品',
  //   intro: '用户可选择以下方案进行投资，享受固定周期的锁仓收益：',
  //   table: {
  //     investment: '投资标的',
  //     period: '周期',
  //     return: '总回报率',
  //     settlement: '结算方式',
  //     row1: {
  //       investment: 'BTC / USDT / SHIB / XRP / DOGE 等',
  //       period: '360天',
  //       return: '300%',
  //       settlement: '本金+收益',
  //     },
  //     row2: {
  //       investment: '平台币 $TRUMPDOGE',
  //       period: '3个月',
  //       return: '150%',
  //       settlement: '币本位结算',
  //     },
  //     row3: {
  //       investment: '平台币 $TRUMPDOGE',
  //       period: '6个月',
  //       return: '220%',
  //       settlement: '币本位结算',
  //     },
  //     row4: {
  //       investment: '平台币 $TRUMPDOGE',
  //       period: '12个月',
  //       return: '360%',
  //       settlement: '币本位结算',
  //     },
  //   },
  //   note: '起投门槛：100 USDT 或其整倍数。',
  // },
  // 推广模型
  dynamic: {
    title: '动态推广模型',
    intro:
      '用户通过推荐新会员加入，可享受其投资额的分润奖励，最高可享受50层社区奖励',
    feature1: {
      title: '收益与自身持仓量挂钩',
      content: '鼓励用户复投与增持，促进生态内循环。',
    },
    feature2: {
      title: '手续费',
      content: '提现收取10%手续费，用于生态维护与通证回购。',
    },
    feature3: {
      title: '制度保障',
      content: '平台承诺制度永久不变，保障会员利益。',
    },
  },
};
